<template>
    <div class="main" style="background-color: #fff;min-height: 100vh">
        <div v-if="lang === 'zh'" class="logo-zh"/>
        <div v-if="lang === 'en'" class="logo-en"/>
        <div class="lang">
            <div @click="setLang('zh')" class="lang-item" :class="{'lang-active':lang==='zh'}">中</div>
            <div @click="setLang('en')" class="lang-item" :class="{'lang-active':lang==='en'}">EN</div>
        </div>
        <div class="find">
            <div class="menu">
                <div @click="setMenu(0)" :class="{'menu-active':menu===0}">
                    {{ lang === 'zh' ? '防伪查询' : 'Anti-Counterfeit Check' }}
                </div>
                <div @click="setMenu(1)" :class="{'menu-active':menu===1}">
                    {{ lang === 'zh' ? '产品信息' : 'Product Info' }}
                </div>
            </div>
            <div class="search" v-show="menu===0">
                <div class="search-line">
                    <input type="text" :placeholder="lang==='zh'?'输入查询数码':'the scratched-off numbers'"
                           spellcheck="false" v-model="code"
                           @input="fixCard"
                           data-ms-editor="true">
                    <div style="position: relative">
                        <van-uploader class="upload" @change="handleFileChange" accept="image/*"
                        />
                        <!--                        <input type="file"  style="width: 100%;height: 100%;opacity:0;">-->
                    </div>
                </div>
                <div class="search-line">
                    <input type="text" :placeholder="lang==='zh'?'输入验证码':'input search code'" spellcheck="false"
                           v-model="password"
                           data-ms-editor="true">
                    <div @click="send">{{ lang === 'zh' ? '查 询' : 'Verify' }}</div>
                </div>
            </div>
            <div v-show="showResult" class="res">
                <img alt="图片加载异常"
                     :src="resIcon" lazy="loaded">
                <div>{{ result }}</div>
            </div>
        </div>
        <div v-show="menu===0">
            <div v-if="lang === 'zh'" class="help-zh"/>
            <div v-if="lang === 'en'" class="help-en"/>
        </div>
        <div v-show="menu===1" class="info" @click="goPdf">
            {{ infoText }}
        </div>
    </div>
    <canvas v-show="false" ref="canvas" width="500" height="500"></canvas>
</template>

<style>


</style>
<script>
import Toast, {showToast} from "vant";
import jsQR from 'jsqr';

export default {
    name: "WorkCardView",
    data() {
        return {
            imageData: null,
            decodedData: null,
            lang: 'zh',
            menu: 0,
            code: '',
            codeFix: '',
            resMsg: '',
            password: '',
            result: '',
            showResult: false,
            active: 0,
            infoText: '在防伪查询菜单点击查询，才可以查询图片信息',
            resIcon: require('../assets/images/error.png'),
            successImage: require('../assets/images/success.png'),
            errorImage: require('../assets/images/error.png')
        }
    },
    created() {
        const params = new URLSearchParams(window.location.search);
        let code = params.get('code');
        let type = params.get('type');
        if (code === undefined || code === null)
            code = '';
        if (code.length > 9)
            code = code.slice(0, 9)
        this.code = code;

        this.codeFix = code;

    },
    mounted() {
    },
    methods: {
        fixCard(card) {
            if (this.code.length === 0)
                this.code = this.codeFix;
        },
        setLang(lang) {
            this.lang = lang;
            this.showResult = false;
            this.result = '';
            if (this.lang === 'zh') {
                this.infoText = '在防伪查询菜单点击查询，才可以查询图片信息';
            } else {
                this.infoText = 'Please click “Anti-Counterfeit Check” to verify, then click “Product Info” to view the product manual.';
            }
        },
        setMenu(menu) {
            this.menu = menu;
            if (menu === 1)
                this.showResult = false;
        },
        handleFileChange(event) {
            const file = event.target.files[0];
            if (!file) return;
            try {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imageData = e.target.result;
                    this.decodeQRCode(e.target.result);
                };
                reader.readAsDataURL(file);
            } catch (e) {

            }

        },
        decodeQRCode(imageData) {
            const img = new Image();
            img.onload = () => {
                let canvasElement = this.$refs.canvas;
                let canvas = canvasElement.getContext('2d');

                canvas.drawImage(img, 10, 10, 500, 500); //缩放
                let imageData = canvas.getImageData(10, 10, 500, 500); //复制画布上指定矩形的像素数据


                // // 根据图片尺寸设置 canvas 大小
                // canvas.width = img.width;
                // canvas.height = img.height;
                // ctx.drawImage(img, 0, 0);

                // const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height);

                if (code) {
                    try {
                        this.decodedData = code.data;
                        let url = new URL(this.decodedData);
                        this.code = url.searchParams.get("code")
                    } catch (e) {
                    }
                } else {
                    this.decodedData = '';
                    showToast('未找到二维码');
                }
            };
            img.src = imageData;
        },
        goPdf() {
            let url = 'http://pts.7000mall.com/pdfjs?file=http://pts.7000mall.com/static/upload/ae7e2b6d70b9f7f7/92949a9576db36c6.pdf';
            if (this.infoText === '电子说明书下载查看' || this.infoText === 'download and view the electronic manual') {
                window.open(url, '_blank');
            }
        },
        send() {
            let data = {
                id: null,
                card: this.code,
                password: this.password
            }
            if (this.password === '' || this.password === undefined) {
                showToast('请输入验证码');
                return;
            }
            let than = this;
            this.$ajax.post("/romossCode/check", data).then((res) => {
                if (res.data.code === 200) {
                    than.showResult = true;
                    if (res.data.data === 1) {
                        if (this.lang === 'zh') {
                            than.result = '您查询的是正品！';
                            than.infoText = '电子说明书下载查看';
                        } else {
                            than.result = 'The product is genuine. ';
                            than.infoText = 'download and view the electronic manual';
                        }
                        than.resIcon = than.successImage;
                    } else {
                        if (this.lang === 'zh') {
                            than.result = '请输入正确的验证码。';
                            than.infoText = '在防伪查询菜单点击查询，才可以查询图片信息';
                        } else {
                            than.result = 'Please enter the correct anti-counterfeiting code.';
                            than.infoText = 'Please click “Anti-Counterfeit Check” to verify, then click “Product Info” to view the product manual.'
                        }
                        than.resIcon = than.errorImage;
                    }
                } else {
                }
            });
            // this.$ajax.post();
        }
    }
}
</script>


<style scoped>

.upload {
    top: 0;
    right: 0;
    position: absolute;
    opacity: 0;
}

.info {
    margin-top: 10px;
    font-size: 12px;
    color: #7bd9d9;
    background-color: #fff;
}

.res > img {
    width: 44px;
    margin-bottom: 17px;
}

.res {
    font-size: 14px;
    width: calc(100vw - 34px);
    padding: 17px;
    background-image: linear-gradient(#81cec7, #5eb5c3);
    border-radius: 5px;
    margin-top: 17px;
    box-shadow: 2px 2px 1px rgba(0, 0, 0, .3);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #fff;
    box-sizing: border-box;
}


.search-line:first-child > div {
    background-image: url('../assets/images/scan.png');
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
}

.search-line > div {
    width: calc(20% - 10px);
    height: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
    background-color: #000;
    color: #fff;
    border-radius: 5px;
}

.search-line > input {
    width: calc(80% - 34px);
    height: inherit;
    border: 1px #e5e6e6 solid;
    border-radius: 5px;
    text-indent: 10px;
    color: #000;
}

.search-line {
    position: relative;
    width: 100%;
    height: 31px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 17px;
    font-size: 14px;
}

.menu-active {
    background-color: #000;
    color: #fff;
}

.menu > div {
    height: 100%;
    line-height: 32px;
    display: inline-block;
    width: 49.9%;
    /*padding-top: 6px;*/
}

.menu {
    width: calc(100% - 34px);
    height: 32px;
    margin: 10px 0 30px 0;
    background-color: #fff;
    border: 1px #e5e6e6 solid;
    border-radius: 5px;
    overflow: hidden;
    font-size: 14px;
    color: #000;
}

.find {
    width: 100%;
    padding: 17px;
    background-color: #fff;
}

.lang {
    position: absolute;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 11px;
    color: #7bd9d9;
    background-color: #fff;
    top: 18px;
    right: 18px;
    border: 1px #fff solid;
    border-radius: 4px;
    overflow: hidden;
}

.lang-active {
    background-color: #7bd9d9;
    color: #fff;
}

.lang-item {
    padding: 2px 7px;
}


.main {
    position: relative;
}

.logo-zh {
    width: 100%;
    height: 41vw;
    background-image: url('../assets/images/logo_zh.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.logo-en {
    width: 100%;
    height: 41vw;
    background-image: url('../assets/images/logo_en.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.help-zh {
    width: 100%;
    height: 310vw;
    background-image: url('../assets/images/help_zh.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.help-en {
    width: 100%;
    height: 310vw;
    background-image: url('../assets/images/help_en.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
}


</style>
